/* Swan Lake Balls — Theme JS */

const SLCart = {
  init() {
    const count = window.SLTHEME.cartCount || 0;
    this.updateCount(count);
    this.initAnimations();
    this.initGradeTabs();
  },

  open() {
    this.fetchAndRender().then(() => {
      document.getElementById('cart-overlay').classList.add('active');
      document.getElementById('cart-drawer').classList.add('open');
      document.body.style.overflow = 'hidden';
    });
  },

  close() {
    document.getElementById('cart-overlay').classList.remove('active');
    document.getElementById('cart-drawer').classList.remove('open');
    document.body.style.overflow = '';
  },

  async fetchAndRender() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      this.render(cart);
    } catch (e) {
      console.error('Cart fetch error:', e);
    }
  },

  render(cart) {
    const itemsEl = document.getElementById('cart-items');
    const footerEl = document.getElementById('cart-footer');
    const emptyEl = document.getElementById('cart-empty');
    if (!itemsEl) return;

    this.updateCount(cart.item_count);
    this.updateShippingBar(cart.total_price);

    const subtotalEl = document.getElementById('cart-subtotal-price');
    if (subtotalEl) subtotalEl.textContent = this.formatMoney(cart.total_price);

    if (cart.item_count === 0) {
      itemsEl.innerHTML = '';
      if (footerEl) footerEl.style.display = 'none';
      if (emptyEl) emptyEl.style.display = 'block';
      return;
    }

    if (emptyEl) emptyEl.style.display = 'none';
    if (footerEl) footerEl.style.display = 'block';

    itemsEl.innerHTML = cart.items.map(item => `
      <div class="cart-item" data-key="${this.esc(item.key)}">
        <div class="cart-item-img">
          ${item.image
            ? `<img src="${item.image.replace(/(\.\w+)$/, '_100x100$1')}" alt="${this.esc(item.product_title)}" loading="lazy">`
            : ''}
        </div>
        <div class="cart-item-info">
          <div class="cart-item-title">${this.esc(item.product_title)}</div>
          ${item.variant_title && item.variant_title !== 'Default Title'
            ? `<div class="cart-item-variant">${this.esc(item.variant_title)}</div>`
            : ''}
          <div class="cart-item-price">${this.formatMoney(item.final_line_price)}</div>
          <div class="cart-item-qty">
            <button onclick="SLCart.changeQty('${this.esc(item.key)}', ${item.quantity - 1})" aria-label="Decrease">−</button>
            <span>${item.quantity}</span>
            <button onclick="SLCart.changeQty('${this.esc(item.key)}', ${item.quantity + 1})" aria-label="Increase">+</button>
          </div>
        </div>
        <button class="cart-item-remove" onclick="SLCart.changeQty('${this.esc(item.key)}', 0)" aria-label="Remove item">&times;</button>
      </div>
    `).join('');
  },

  async addToCart(button) {
    const variantId = button.dataset.variantId;
    const title = button.dataset.productTitle || '';
    const price = parseInt(button.dataset.productPrice || '0', 10);
    const original = button.textContent;

    button.textContent = 'Adding…';
    button.disabled = true;

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      });

      if (!res.ok) {
        const err = await res.json();
        throw new Error(err.description || 'Failed to add');
      }

      if (typeof fbq !== 'undefined') {
        fbq('track', 'AddToCart', {
          content_type: 'product',
          content_ids: [variantId],
          content_name: title,
          value: price / 100,
          currency: 'EUR'
        });
      }

      button.textContent = 'Added!';
      setTimeout(() => {
        button.textContent = original;
        button.disabled = false;
      }, 1800);

      this.open();
    } catch (err) {
      button.textContent = 'Error — try again';
      button.disabled = false;
      setTimeout(() => {
        button.textContent = original;
        button.disabled = false;
      }, 2500);
    }
  },

  async changeQty(key, qty) {
    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      });
      const cart = await res.json();
      this.render(cart);
    } catch (e) {
      console.error('Cart change error:', e);
    }
  },

  updateCount(count) {
    const el = document.getElementById('cart-count');
    if (!el) return;
    el.textContent = count;
    el.style.display = count > 0 ? 'flex' : 'none';
  },

  updateShippingBar(totalCents) {
    const threshold = window.SLTHEME.freeShippingThreshold || 5000;
    const fillEl = document.getElementById('shipping-bar-fill');
    const textEl = document.getElementById('shipping-bar-text');
    if (!fillEl || !textEl) return;

    if (totalCents >= threshold) {
      textEl.textContent = 'You qualify for free shipping!';
      fillEl.style.width = '100%';
      fillEl.style.background = '#2e7d32';
    } else {
      const remaining = threshold - totalCents;
      textEl.textContent = `Add ${this.formatMoney(remaining)} more for free shipping`;
      const pct = Math.min((totalCents / threshold) * 100, 100);
      fillEl.style.width = pct + '%';
      fillEl.style.background = '';
    }
  },

  formatMoney(cents) {
    const amount = cents / 100;
    return '€' + (Number.isInteger(amount) ? amount : amount.toFixed(2));
  },

  esc(str) {
    return String(str).replace(/[&<>"']/g, c => ({
      '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
    }[c]));
  },

  trackCheckout() {
    if (typeof fbq !== 'undefined') {
      fbq('track', 'InitiateCheckout');
    }
  },

  initAnimations() {
    if (!('IntersectionObserver' in window)) return;
    const io = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          e.target.classList.add('visible');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
    document.querySelectorAll('.fade-up').forEach(el => io.observe(el));
  },

  initGradeTabs() {
    /* Show mint by default; hide grade-a until tab click */
    document.querySelectorAll('.product-card[data-grade="grade-a"]').forEach(c => c.classList.remove('show'));
    document.querySelectorAll('.product-card[data-grade="mint"]').forEach(c => c.classList.add('show'));
  }
};

/* Global helpers referenced by inline onclick attributes */
function addToCart(btn) { SLCart.addToCart(btn); }

function filterGrade(e, grade) {
  document.querySelectorAll('.grade-tab').forEach(t => t.classList.remove('active'));
  e.target.classList.add('active');
  document.querySelectorAll('.product-card').forEach(card => {
    if (grade === 'all' || card.dataset.grade === grade) {
      card.classList.add('show');
    } else {
      card.classList.remove('show');
    }
  });
}

/* Product variant picker */
function selectVariant(btn) {
  document.querySelectorAll('.variant-btn').forEach(function(b){ b.classList.remove('active'); });
  btn.classList.add('active');

  var price    = parseInt(btn.dataset.price, 10);
  var priceInt = Math.floor(price / 100);
  var variantId = btn.dataset.variantId;
  var available = btn.dataset.available === 'true';

  var priceEl = document.getElementById('price-amount');
  if (priceEl) priceEl.textContent = priceInt;

  var addBtn = document.getElementById('product-add-btn');
  if (addBtn) {
    addBtn.dataset.variantId   = variantId;
    addBtn.dataset.productPrice = price;
    if (available) {
      addBtn.textContent = 'Add to Bag — €' + priceInt;
      addBtn.disabled    = false;
      addBtn.classList.remove('sold-out-btn');
    } else {
      addBtn.textContent = 'Sold Out';
      addBtn.disabled    = true;
      addBtn.classList.add('sold-out-btn');
    }
  }
}

/* Shop page filtering */
var shopActiveBrand = 'all';

function shopFilterBrand(btn, brand) {
  shopActiveBrand = brand;
  document.querySelectorAll('.brand-filter-btn').forEach(function(b){ b.classList.remove('active'); });
  btn.classList.add('active');
  shopApplyFilters();
}

function shopReset() {
  shopActiveBrand = 'all';
  document.querySelectorAll('.brand-filter-btn').forEach(function(b, i){ b.classList.toggle('active', i === 0); });
  shopApplyFilters();
}

function shopApplyFilters() {
  var cards = document.querySelectorAll('.shop-card');
  var visible = 0;
  cards.forEach(function(card) {
    var show = shopActiveBrand === 'all' || card.dataset.brand === shopActiveBrand;
    card.style.display = show ? '' : 'none';
    if (show) visible++;
  });
  var el = document.getElementById('filter-results');
  if (el) el.textContent = visible + ' product' + (visible !== 1 ? 's' : '');
  var empty = document.getElementById('shop-empty');
  if (empty) empty.style.display = visible === 0 ? 'block' : 'none';
}

function swapProductImg(btn, url) {
  const main = document.getElementById('product-main-img');
  if (main) {
    main.style.opacity = '0';
    setTimeout(() => { main.src = url; main.style.opacity = '1'; }, 160);
  }
  document.querySelectorAll('.product-thumb').forEach(t => t.classList.remove('active'));
  btn.classList.add('active');
}

document.addEventListener('DOMContentLoaded', () => SLCart.init());
